
import { isSp } from '@/js/_common';

const main = () => {
    if (document.querySelector('.c-parts-job-search-filter') == null) return;

    const parent = document.querySelector('.c-parts-job-search-filter');

    // 詳細検索の開く動作
    parent.querySelector('.js-detail-open').addEventListener('click', (e) => {
        e.preventDefault();
        parent.querySelector('.c-search-detail').dataset.open = true;
    });

    // 詳細検索の閉じる動作
    parent.querySelector('.js-detail-close').addEventListener('click', (e) => {
        e.preventDefault();
        parent.querySelector('.c-search-detail').dataset.open = false;
        let count = 0;
        parent.querySelectorAll('label.checkbox input[type="checkbox"]').forEach((el) => {
            if(el.checked){
                count++;
            }
        });
        parent.querySelector('.js-detail-open .count').textContent = count ? count : '';
    });

    // キーワード入力フォーカス時の動作
    parent.querySelector('.js-keyword-input').addEventListener('focus', (e) => {
        if (!isSp()) return;
        parent.querySelector('.js-keyword-input-sp').dataset.open = true;
        parent.querySelector('.js-keyword-input-sp input').value = parent.querySelector('.js-keyword-input').value;
        parent.querySelector('.js-keyword-input-sp input').focus();
    });

    // spでのキーワード入力終了
    parent.querySelector('.js-keyword-input-sp-close').addEventListener('click', (e) => {
        parent.querySelector('.js-keyword-input').focus();
        parent.querySelector('.js-keyword-input-sp').dataset.open = false;
    });

    // spでのキーワード文字入力時
    parent.querySelector('.js-keyword-input-sp input').addEventListener('input', (e) => {
        parent.querySelector('.js-keyword-input-sp-submit .text').textContent = e.target.value;
        parent.querySelector('.js-keyword-input').value = e.target.value;
        if (e.target.value.length > 0) {
            parent.querySelector('.js-keyword-input-sp-submit').dataset.active = true;
        } else {
            parent.querySelector('.js-keyword-input-sp-submit').dataset.active = false;
        }
    });

    // spでのキーワード入力確定
    parent.querySelector('.js-keyword-input-sp-submit').addEventListener('click', (e) => {
        parent.querySelector('form').submit();
    });

    // リセットボタン動作
    parent.querySelector('form button.reset').addEventListener('click', (e) => {
        parent.querySelectorAll('input[type="text"]').forEach((el) => {
            el.value = '';
        });
        parent.querySelectorAll('input[type="checkbox"]').forEach((el) => {
            el.checked = false;
        });
    });


    // スクロール時の検索バー固定動作
    const scrollIo = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            document.querySelector('.c-parts-job-search-filter').dataset.fixedSp = false;
        } else {
            document.querySelector('.c-parts-job-search-filter').dataset.fixedSp = true;
        }
    }, {
        rootMargin: '-66px 0px',
        threshold: 1,
    });
    scrollIo.observe(document.querySelector('.c-layouts-col2__side'));
}

export default main;
